define('SageDotCom/DataLayer/Global/links',['jquery',
    'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/exitLinkClick',
        'SageDotCom/DataLayer/Events/internalLinkClick',
        'SageDotCom/DataLayer/Events/fileDownload',
        'SageDotCom/DataLayer/Util/urlHelper',
        'SageDotCom/DataLayer/Util/trackingHelper',
        'SageDotCom/PolyFills/hasAttribute',
        'SageDotCom/PolyFills/closest'],
    function ($, analytics, exitLinkEvent, internalLinkEvent, fileDownloadEvent, urlHelper, trackingHelper) {
        function globalLinkTracking() { }

        globalLinkTracking.prototype.initialize = function initialize() {
            var componentRegistrations = [];

            // find all anchors not nested inside a tracked element
            $(".score-content-spot a, .score-breadcrumb a, .score-section-menu a, .score-button-menu-item a, .score-site-map a, .download-item-wrapper a, .score-menu-list a")
                .not("header a, footer a, .sticky-navigation a")
                .each(function (key, value) {
                    var component = value.closest("[id]");

                    // only attach events if component does not already have explicit tracking
                    if (!component.hasAttribute("data-tracking") && !component.hasAttribute("data-xpr-state") && !value.hasAttribute("data-tracking")) {

                        // internal URL?  only if hostname is blank or matches current browser URL
                        if (!value.hostname || !value.hostname.length || location.hostname.toLowerCase() === value.hostname.toLowerCase()) {
                            // handle file download vs internal link click
                            var fileTester = urlHelper.isFile(value.href);
                            if (fileTester.isFile === true && fileTester.fileName) {
                                $(value).on('click', function (event) {
                                    var data = fileDownloadEvent.GenerateEventMetadata(event.currentTarget, fileTester.fileName);
                                    analytics.event(data);
                                });
                                componentRegistrations.push({ obj: component, name: fileDownloadEvent.getName() });
                            } else {
                                $(value).on('click', function (event) {
                                    var data = internalLinkEvent.GenerateEventMetadata(event.currentTarget);
                                    analytics.event(data);
                                });
                                componentRegistrations.push({ obj: component, name: internalLinkEvent.getName() });
                            }
                        } else { // external URL
                            $(value).on('click', function (event) {
                                var data = exitLinkEvent.GenerateEventMetadata(event.currentTarget);
                                analytics.event(data);
                            });
                            componentRegistrations.push({ obj: component, name: exitLinkEvent.getName() });
                        }
                    }
                });

            componentRegistrations.forEach(function(elem) {
                trackingHelper.registerTracking(elem.obj, elem.name);
            });

            // track anchors across commerce module accordingly
            $(".commerce-page").find('a').each(function (key, value) {
                value.addEventListener('click', onLinkClick);
            });
        }

        function onLinkClick(e) {
            var link = e.currentTarget;
            var component = link.closest("[id]");

            // Skip tracking if component have already explicit tracking attribute
            if (component.hasAttribute("data-tracking") || component.hasAttribute("data-xpr-state") || link.hasAttribute("data-tracking") || link.hasAttribute("data-xpr-state")) return;

            var data;
            // internal URL?  only if hostname is blank or matches current browser URL
            if (!link.hostname || !link.hostname.length || location.hostname.toLowerCase() === link.hostname.toLowerCase()) {
                // handle file download vs internal link click
                var fileTester = urlHelper.isFile(link.href);
                if (fileTester.isFile === true && fileTester.fileName) {
                    data = fileDownloadEvent.GenerateEventMetadata(link, fileTester.fileName);
                } else {
                    data = internalLinkEvent.GenerateEventMetadata(link);
                }
            } else { // external URL
                data = exitLinkEvent.GenerateEventMetadata(link);
            }

            analytics.event(data);
        }

        return new globalLinkTracking();
    });
